const padStart = (string: string, length: number, padding: string) => {
  const array: string[] = [];
  while (string.length + array.length < length) {
    array.push(padding);
  }
  return array.join('') + string;
};

export class Time {
  hours: number;
  minutes: number;
  seconds: number;

  // All time variables are stored as local device time.
  constructor(hours: number, minutes: number, seconds: number) {
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;
  }

  toLocalString(): string {
    const hrs = padStart(this.hours.toString(), 2, '0');
    const mins = padStart(this.minutes.toString(), 2, '0');
    const secs = padStart(this.seconds.toString(), 2, '0');
    return `${hrs}:${mins}:${secs}`;
  }

  toHumanString(): string {
    const hrs = ((this.hours % 12 === 0) ? 12 : this.hours % 12).toString();
    const mins = padStart(this.minutes.toString(), 2, '0');
    const ampm = this.hours < 12 ? 'AM' : 'PM';
    return `${hrs}:${mins} ${ampm}`;
  }

  toDate(): Date {
    return new Date(2000, 1, 1, this.hours, this.minutes, this.seconds, 0);
  }

  static getTime(datetime: Date): Time {
    const hr = datetime.getHours();
    const min = datetime.getMinutes();
    const sec = datetime.getSeconds();
    return new Time(hr, min, sec);
  }

  static parseLocal(timestr: string | undefined): Time {
    if (timestr == null) {
      return new Time(0, 0, 0);
    }
    const arr = timestr.split(':');
    return new Time(+arr[0], +arr[1], +arr[2]);
  }
}

export default Time;

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
